import {
  ROUTER_PATHS,
  useCheckPermissionsArray,
  useTableFilter,
  useTableServerSideFiltering,
} from "@/shared";
import { GeneralTable, SingleTableBoxScene } from "@/shared/components/ui";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PermissionsEnum } from "@/auth/interfaces";
import { useFetchGetProductoServicio } from "@/shared/actions/erp/producto_servicio.action";
import { IProductoServicio } from "@/shared/interfaces/erp/administration/producto_servicio.interface";
import { useTableColumnsProductoServicio } from "../../shared/hook/useTableColumnsProductoServicio";

export default function ProductoServicioPage() {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_producto,
    PermissionsEnum.api_add_producto,
    PermissionsEnum.api_change_producto,
  ])

  const navigate = useNavigate();

  const {
    filterObject,
    columnFilters,
    setColumnFilters
  } = useTableServerSideFiltering();


  const { pagination, searchTerm, setPagination } = useTableFilter();

  const { pageIndex, pageSize } = pagination;

  const {
    isLoading,
    data: productoRes,
    isRefetching,
  } = useFetchGetProductoServicio({
    page: pageIndex + 1,
    page_size: pageSize,
    codigo: searchTerm,
    ...filterObject,
    filterByState: false,
  });

  const {
    columnBase
  } = useTableColumnsProductoServicio()

  const onEdit = (e: IProductoServicio) => {
    navigate(`${ROUTER_PATHS.inventario.servicioEditareNav}/${e.id_servicio}`);
  };


  return (
    <SingleTableBoxScene
      title="Servicio"
      visibleReport={false}
      urlRedirect={ROUTER_PATHS.inventario.servicioCreateNav}
      enableRedirect={true}

    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GeneralTable<IProductoServicio>
            columns={columnBase}
            data={productoRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={productoRes?.data?.count}
            // // actions
            actionsColumnSize={120}
            ///* filters - server side
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}
            enableSorting={false}
            // crud
            onEdit={onEdit}
            canDelete={false}
            positionActionsColumn="first"
          />
        </Grid>
      </Grid>
    </SingleTableBoxScene>
  );
}
